import PaymentService from "@/services/Payment";
import Inputmask from "inputmask";


const state = {
    balance: '',
    balance_masked: '',
    pay_type:[],
    history:[]
};


const actions = {
    load_balance: function (store) {
        PaymentService.getBalance().then((response) => {
            store.commit('SET_BALANCE', response.data.balance)
        })
    },
    get_paytype:function(store){
        PaymentService.getPayType().then((response) => {
            store.commit('SET_PAYTYPE', response.data)
        })
    },
    load_history: function(store,request = { page: 1, limit: 15, start_date: '', finish_date: '', operation: '' }){
        PaymentService.history(request).then((response)=>{
            store.commit('SET_HISTORY',response.data);
        })
        
    }

}
const mutations = {
    SET_BALANCE: function (state, balance = '') {
        let balance_masked = Inputmask.format(balance, {
            alias: "decimal",
            groupSeparator: " ",
            radixPoint: ".",
            digits: 0,
            autoGroup: true,
            repeat: 9,
            allowMinus: false
        });
        state.balance = balance;
        state.balance_masked = balance_masked;
    },
    SET_PAYTYPE:function(state, data=[]){
        state.pay_type = data;
    },
    SET_HISTORY:function(state,data=[]){
        state.history = data;
    }
}
const getters = {
    balance: function (state) {
        return state.balance;
    },
    balance_masked: function (state) {
        return state.balance_masked;
    },
    get_paytype:function(state){
        return state.pay_type;
    },
    history:function(state){
        return state.history
    }
}



export default {
    state,
    mutations,
    getters,
    actions
};
